/** Copyright © 2024 Qcells. All rights reserved.
This software is proprietary and confidential. Unauthorized use,
duplication, or distribution of software is strictly prohibited.
*/
import { setupWorker } from 'msw';

import handlers from './handlers';

export const worker = setupWorker(...handlers);
